const snacksNoticePopUpTranslations = {
  title: "انتبه",
  description: "هذه هي كل وجباتك الخفيفة ، عليك أن تأكلها جميعا خلال يومك",
  actionButton: "الغاء",
};

export default snacksNoticePopUpTranslations;
